module.exports = {
  production: false,
  mexExchange: {
    api: {
      baseUrl: '/api',
      pageSize: 25,
      request: {
        timeout: 15000,
        timeoutRetries: 1,
        retryTimeout: 3000,
      },
      dateFormat: 'YYYY-MM-DDTHH:mm:ss',
      endpoints: {
        healthCheck: '/healthcheck',
        login: '/login',
        refreshToken: '/refresh',
        user: {
          me: '/user/me',
          resetTempPassword: '/reset-temporary-password',
        },
        customer: {
          dealCode: '/deal_code',
          dealCodeById: '/deal_code/:id',
          dealCodeByDealCode:'/deal_code/deal_code/:dealCode',
          usersByDealCodeId: '/deal_code/:id/users',
          toggleDealCode: '/deal_code/:id/toggle',
          firm: '/firm',
          firmById: '/firm/:id',
          toggleFirm: '/firm/:id/toggle',
          alertTypes: '/firm/subscriptions',
          alertSubscriptionByFirmId: '/firm/subscriptions/subscribed/:id',
          lp: '/lp',
          lpById: '/lp/:id',
          lpStreams: '/lp/streams/all',
          dealCodesByFirmId: '/firm/:id/deal_codes',
          user: '/user',
          userById: '/user/:id',
          usersByFirmId: '/user/firm/:id',
          toggleUser: '/user/:id/toggle',
          roles: '/roles',
          changePassword: '/change_password',
          generateAnnonId: '/user/annonid/generate',
          resetUserPass: '/user/reset/:id',
          liquidityProvider: '/liquidity-provider',
          liquidityProviderById: '/liquidity-provider/:id',
          liquidityProviderFlow: '/liquidity-provider/flow-names',
          mexVenue: '/mex-venue',
          mexVenueById: '/mex-venue/:id',
          mexVenueSymbol: '/mex-venue-symbol',
          mexVenueSymbolById: '/mex-venue-symbol/:id',
          mexVenueCpty: '/mex-venue-cp',
          mexVenueCptyById: '/mex-venue-cp/:id',
          mexVenueAccount: '/mex-venue-account',
          mexVenueAccountById: '/mex-venue-account/:id',
          clientEntitlement: '/rfs-entitlement',
          clientEntitlementById: '/rfs-entitlement/:id',
          clientGroup: '/rfs-group',
          clientGroupById: '/rfs-group/:id'
        },
        settings: {
          currencies: '/currency',
          currencyById: '/currency/:id',
          symbols: '/symbols',
          symbolById: '/symbols/:id',
          instruments: '/symbols/instruments',
          tenors: '/symbols/tenors',
          nodes: '/symbols/nodes',
          synapseNodes: '/symbols/synapse-nodes',
          toggleSymbol: '/symbols/:id/toggle',
          toggleCurrency: '/currency/:id/toggle',
          holidays: '/holiday',
          holidaysById: '/holiday/:id',
          toggleHoliday: '/holiday/:id/toggle',
          tradeDates: '/trade-date/search',
          tradeDatesById: '/trade-date/:id',
          tradeDateEndOfDayEvent: '/trade-date/trigger-eod-event',
          forecastTradeDate: '/trade-date/forecast-trade-date',
          valueDates: '/value-date',
          valueDatesSearch: '/value-date/search',
          valueDatesById: '/value-date/:id',
          valueDateScan: '/value-date/parser/scan'
        },
        risk: {
          creditLine: '/credit_line',
          creditLineSearch: '/credit_line/search',
          creditLineById: '/credit_line/:id',
          creditSupervisor: '/credit_supervisor',
          creditSupervisorById: '/credit_supervisor/:id',
          creditPowersById: '/credit_supervisor/powers/:id',
          calculationMethod: '/credit_line/calculation_methods',
          assetGroup: '/asset-group',
          assetGroupById: '/asset-group/:id',
          assetGroupTemplate: '/asset-group/templates/all',
          cptyBlocking: '/credit_line',
          cptyBlockingById: '/credit_line/:id'
        },
        trading: {
          trades: '/trades',
          orders: '/orders',
          rfeOrderById: '/rfe-orders/:id',
          positions: '/positions',
          positionsByCurrency: '/positions/ccy',
          positionsHistory: '/positions/history',
          deletePositionsByEntity: '/positions/mex/:entityType/:entityId',
          openPositionsByFirm: '/positions/open/:firmId'
        },
        engineering: {
          services: '/functions/services-basic',
          servicesDetailed: '/functions/services-detailed',
          fixServices: '/functions/fix-services',
          startService: '/functions/services/start/:serviceName',
          reStartService: '/functions/services/restart/:serviceName',
          stopService: '/functions/services/stop/:serviceName',
          serviceStatus: '/functions/services/status/:serviceName',
          logLevel: '/functions/loglevel',
          cache: '/cache',
          marketStatus: '/system-event/:serviceName/marketStatus/:marketStatus',
          migrateBrokerLink: '/:entityType/migrate-broker-link',
          migrateBrokerLinkAll: '/migrateall',
          fixConfig: '/fix-config',
          fixConfigById: '/fix-config/:id',
          activateFixConfig: '/fix-config/:id/activate',
          deactivateFixConfig: '/fix-config/:id/deactivate',
          fixSessions: '/functions/fix-sessions',
          fixSessionsAll: '/functions/fix-sessions/all',
          scanFTPHoliday: '/holiday/parser/parse',
          acceptFTPHoliday: '/holiday/parser/accept',
          upgradeLibrary: '/functions/:upgrade-library',
          syncRates: '/rates/migrate-broker-link',
          updateFIXSessionSeqNumber: '/functions/fix-sessions/:type/:serviceName',
          auditTrail: '/audit',
          orderBreakGlass: '/orders/breakglass/:id',
          executionReportBreakGlass: '/orders/breakglass-execution-report',
          getBreakglassOrder: '/orders/breakglass-get-order/:id',
          oneZeroFlowControl: '/config/onezero-retail/enabled/:toggle',
          oneZeroOneByOne: '/config/onezero-retail/justonce/:toggle',
          oneZeroProcessOrder: '/config/onezero-retail/donow',
          rfeCaptureControl: '/config/ref-order-capture/enabled/:toggle',
          rfeCaptureControlRES: '/config/ref-order-capture-res/enabled/:toggle',
          userConfig: '/config',
          initializeFirms: '/velio/gateway/config/generate/mock',
          natwestGo: '/natwest/generate',
          rerunDropcopies: '/dropcopy/remove-ack/source/:source/target/:target/exchangeIds/:exchangeIds',
          addDropcopies: '/dropcopy/add-ack/source/:source/target/:target/exchangeIds/:exchangeIds',
          runBarrierMessage: '/functions/barrier-to-db-orders-topic',
          validateConfiguration: '/functions/validate-configuration',
          bulkUploadLiquidityPool: '/lp/bulk-upload/stream-assignments',
          bulkUploadGetTemplateFile: '/lp/bulk-upload/stream-assignments/template',
          referenceRatesUpload: '/reference-rate/upload',
          regressionStatus: '/functions/regression',
          regressionToggle: '/functions/regression/:toggle'
        },
        marketOps: {
          liquidityGateway: '/liquidity-gateway-session',
          liquidityGatewayById: '/liquidity-gateway-session/:id',
          toggleActiveLiquidityGateway: '/liquidity-gateway-session/:id/toggle/session',
          toggleLoggingLiquidityGateway: '/liquidity-gateway-session/:id/toggle/logging',
          toggleResetSeqNumLiquidityGateway: '/liquidity-gateway-session/:id/toggle/resetSequenceNumbers',
          toggleMDStatsLiquidityGateway: '/liquidity-gateway-session/:id/md-symbol-stats-enable/:status',
          liveStatus: '/liquidity-gateway-session/live/search',
          liveStatusAllEnvironment: '/liquidity-gateway-session/live/search/all',
          sequenceNumber: '/liquidity-gateway-session/:sessionId/sequence/:inbound/:outbound',
          refreshStatus: '/liquidity-gateway-session/:id/refresh',
          alertSetting: '/notification-settings',
          alertSettingById: '/notification-settings/:id',
          alertSettingTypes: '/notification-settings/types/descriptions',
          alertSubscriptionsByType: '/notification-settings/type/:alertType/firms',
          activeSessions: '/liquidity-gateway-session/active',
          modules: '/liquidity-gateway-session/modules'
        },
        reports: {
          list: '/data_export',
          download: '/data_export/export_url/:key',
          export: '/:entityType/export',
          dailyVolume: '/business-report/daily-volumes',
          weeklySpreads: '/business-report/weekly-spreads',
          weeklySpreadsLPs: '/business-report/weekly-spreads/lps',
          priceImprovement: '/business-report/price-improvement',
          businessReportExport: '/business-report/:reportType/export',
          fillRatesByDC: '/business-report/fill-rate-by-dealcode',
          fillRatesRFEByDC: '/business-report/fill-rate-by-dealcode/taker/:dealCode',
          clientVolumeBySymbol: '/business-report/client-volume-symbol',
          symbolVolume: '/business-report/symbol-volume',
          topSellers: '/business-report/top-symbol-volumes',
        },
        dropcopy: {
          deleteExecutionReport: '/dropcopy/broker-link/firm/:id',
          deleteMarginSummary: '/margin/broker-link/firm/:id',
          deletePositionSummary: '/positions/broker-link/firm/:id',
        },
        notifications: {
          list: '/badge/search',
          count: '/badge/admin/count',
          notificationById: '/badge/:id',
          seenById: '/badge/seen/:id',
          sendNotification: '/notification/send'
        },
        margin: {
          entityGroup: '/entity-group',
          entityGroupById: '/entity-group/:id',
          venue: '/venue',
          assetAccount: '/asset-account',
          assetAccountById: '/asset-account/:id',
          assetAccountEntity: '/entity',
          marginSupervisor: '/margin_supervisor',
          marginSupervisorById: '/margin_supervisor/:id',
          marginSupervisorMargin: '/margin_supervisor/:firmId/margin',
          marginSupervisorOrder: '/margin_supervisor/:firmId/orders',
          marginSupervisorEvent: '/margin_supervisor/:firmId/events',
          marginTier: '/margin-tier',
          marginTierById: '/margin-tier/:id',
          createLiquidationInstruction: '/margin_supervisor/events/entry',
          currencyExposure: '/asset-multiplier',
          currencyExposureById: '/asset-multiplier/:id',
          txManager: '/ledger',
          txManagerFilter: '/ledger/filter',
          txManagerById: '/ledger/:id',
          rollEvent: '/margin/roll-events',
          rollEventList: '/margin/roll-events/list',
          rollEventById: '/margin/roll-events/:id',
          rollEventTypes: '/margin/roll-events/types'
        },
        liquidation: {
          killSwitch: '/liquidation/kill-switch'
        },
        matchingEngine: {
          tradingControl: '/trading-control',
          tradingControlById: '/trading-control/:id',
          toggleSymbolInstrument: '/trading-control/:id/toggle',
          toggleGlobalTrading: '/trading-control/global/toggle/:enabled',
          getGlobalTradingFlag: '/trading-control/global/toggle',
          entityControl: '/entity-instrument-trading-control',
          entityControlById: '/entity-instrument-trading-control/:id',
          entityControlSearch: '/entity-instrument-trading-control/search',
          toggleClientInstrument: '/entity-instrument-trading-control/:id/toggle',
          spreadAssignment: '/spread-group',
          spreadAssignmentById: '/spread-group/:id'
        }
      }
    },
    websockets: {
      url: '/ws'
    },
  }
};
